var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowFirst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_831",
    "data-name": "\\uADF8\\uB8F9 831",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #a8a8a8;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_21",
    "data-name": "\\uC0AC\\uAC01\\uD615 21",
    className: "cls-1",
    width: 12,
    height: 12,
    transform: "translate(12) rotate(90)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_829",
    "data-name": "\\uADF8\\uB8F9 829",
    transform: "translate(0.271 0.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    className: "cls-2",
    d: "M5.469,6.458a.986.986,0,0,1-.7-.29L.29,1.689a.989.989,0,0,1,1.4-1.4l3.78,3.78L9.249.29a.989.989,0,0,1,1.4,1.4L6.169,6.168a.986.986,0,0,1-.7.29",
    transform: "translate(11.458 0) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_210",
    "data-name": "\\uD328\\uC2A4 210",
    className: "cls-2",
    d: "M5.469,6.458a.986.986,0,0,1-.7-.29L.29,1.689a.989.989,0,0,1,1.4-1.4l3.78,3.78L9.249.29a.989.989,0,0,1,1.4,1.4L6.169,6.168a.986.986,0,0,1-.7.29",
    transform: "translate(6.458 0) rotate(90)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowFirst);
export default __webpack_public_path__ + "static/media/ic-arrow-first.90a3faf22dfd18eee167f11690be8161.svg";
export { ForwardRef as ReactComponent };